/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackOfficeApiKeyScopeUsageRecord
 */
export interface BackOfficeApiKeyScopeUsageRecord {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyScopeUsageRecord
     */
    lastUsedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyScopeUsageRecord
     */
    scope: string;
}

/**
 * Check if a given object implements the BackOfficeApiKeyScopeUsageRecord interface.
 */
export function instanceOfBackOfficeApiKeyScopeUsageRecord(value: object): value is BackOfficeApiKeyScopeUsageRecord {
    if (!('lastUsedAt' in value) || value['lastUsedAt'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyScopeUsageRecordFromJSON(json: any): BackOfficeApiKeyScopeUsageRecord {
    return BackOfficeApiKeyScopeUsageRecordFromJSONTyped(json, false);
}

export function BackOfficeApiKeyScopeUsageRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyScopeUsageRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'lastUsedAt': json['lastUsedAt'],
        'scope': json['scope'],
    };
}

export function BackOfficeApiKeyScopeUsageRecordToJSON(value?: BackOfficeApiKeyScopeUsageRecord | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lastUsedAt': value['lastUsedAt'],
        'scope': value['scope'],
    };
}

